/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as KioskRouteImport } from './routes/kiosk'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as DevDesignRouteImport } from './routes/dev/design'
import { Route as InviteTokenRouteImport } from './routes/invite.$token'
import { Route as AppCOrgIdRouteImport } from './routes/_app/c/$orgId'
import { Route as AppGodsCompaniesRouteImport } from './routes/_app/gods/companies'
import { Route as AppGodsListRouteImport } from './routes/_app/gods/list'
import { Route as AppCOrgIdIndexRouteImport } from './routes/_app/c/$orgId/index'
import { Route as AppCOrgIdBranchesRouteImport } from './routes/_app/c/$orgId/branches'
import { Route as AppCOrgIdMyWorkRouteImport } from './routes/_app/c/$orgId/my-work'
import { Route as AppCOrgIdOverviewRouteImport } from './routes/_app/c/$orgId/overview'
import { Route as AppCOrgIdProfileRouteImport } from './routes/_app/c/$orgId/profile'
import { Route as AppCOrgIdStaffRouteImport } from './routes/_app/c/$orgId/staff'
import { Route as AppCOrgIdCashIndexRouteImport } from './routes/_app/c/$orgId/cash/index'
import { Route as AppCOrgIdCashHistoryRouteImport } from './routes/_app/c/$orgId/cash/history'
import { Route as AppCOrgIdClientsIndexRouteImport } from './routes/_app/c/$orgId/clients/index'
import { Route as AppCOrgIdClientsClientIdRouteImport } from './routes/_app/c/$orgId/clients/$clientId'
import { Route as AppCOrgIdEntryIndexRouteImport } from './routes/_app/c/$orgId/entry/index'
import { Route as AppCOrgIdEntryInsideRouteImport } from './routes/_app/c/$orgId/entry/inside'
import { Route as AppCOrgIdEntryLockersRouteImport } from './routes/_app/c/$orgId/entry/lockers'
import { Route as AppCOrgIdEntryLogRouteImport } from './routes/_app/c/$orgId/entry/log'
import { Route as AppCOrgIdEntrySettingsRouteImport } from './routes/_app/c/$orgId/entry/settings'
import { Route as AppCOrgIdEntryStatsRouteImport } from './routes/_app/c/$orgId/entry/stats'
import { Route as AppCOrgIdGoodsIndexRouteImport } from './routes/_app/c/$orgId/goods/index'
import { Route as AppCOrgIdGoodsProductIdRouteImport } from './routes/_app/c/$orgId/goods/$productId'
import { Route as AppCOrgIdGoodsDocumentsRouteImport } from './routes/_app/c/$orgId/goods/documents'
import { Route as AppCOrgIdGoodsSalesRouteImport } from './routes/_app/c/$orgId/goods/sales'
import { Route as AppCOrgIdPassesIndexRouteImport } from './routes/_app/c/$orgId/passes/index'
import { Route as AppCOrgIdPassesSoldRouteImport } from './routes/_app/c/$orgId/passes/sold'
import { Route as AppCOrgIdPayrollIndexRouteImport } from './routes/_app/c/$orgId/payroll/index'
import { Route as AppCOrgIdPayrollSalariesRouteImport } from './routes/_app/c/$orgId/payroll/salaries'
import { Route as AppCOrgIdRolesIndexRouteImport } from './routes/_app/c/$orgId/roles/index'
import { Route as AppCOrgIdRolesRoleIdRouteImport } from './routes/_app/c/$orgId/roles/$roleId'
import { Route as AppCOrgIdRolesNewRouteImport } from './routes/_app/c/$orgId/roles/new'
import { Route as AppCOrgIdServicesIndexRouteImport } from './routes/_app/c/$orgId/services/index'
import { Route as AppCOrgIdServicesAnalyticsRouteImport } from './routes/_app/c/$orgId/services/analytics'
import { Route as AppCOrgIdServicesCatalogueRouteImport } from './routes/_app/c/$orgId/services/catalogue'
import { Route as AppCOrgIdServicesHoursRouteImport } from './routes/_app/c/$orgId/services/hours'
import { Route as AppCOrgIdServicesTimetableRouteImport } from './routes/_app/c/$orgId/services/timetable'
import { Route as AppCOrgIdSettingsIndexRouteImport } from './routes/_app/c/$orgId/settings/index'
import { Route as AppCOrgIdSettingsCashRouteImport } from './routes/_app/c/$orgId/settings/cash'
import { Route as AppCOrgIdPassesPlansIndexRouteImport } from './routes/_app/c/$orgId/passes/plans/index'
import { Route as AppCOrgIdPassesPlansPlanIdRouteImport } from './routes/_app/c/$orgId/passes/plans/$planId'
import { Route as AppCOrgIdPassesPlansNewRouteImport } from './routes/_app/c/$orgId/passes/plans/new'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const KioskRoute = KioskRouteImport.update({
  id: '/kiosk',
  path: '/kiosk',
  getParentRoute: () => rootRouteImport,
} as any)
const SignInRoute = SignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const DevDesignRoute = DevDesignRouteImport.update({
  id: '/dev/design',
  path: '/dev/design',
  getParentRoute: () => rootRouteImport,
} as any)
const InviteTokenRoute = InviteTokenRouteImport.update({
  id: '/invite/$token',
  path: '/invite/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AppCOrgIdRoute = AppCOrgIdRouteImport.update({
  id: '/c/$orgId',
  path: '/c/$orgId',
  getParentRoute: () => AppRoute,
} as any)
const AppGodsCompaniesRoute = AppGodsCompaniesRouteImport.update({
  id: '/gods/companies',
  path: '/gods/companies',
  getParentRoute: () => AppRoute,
} as any)
const AppGodsListRoute = AppGodsListRouteImport.update({
  id: '/gods/list',
  path: '/gods/list',
  getParentRoute: () => AppRoute,
} as any)
const AppCOrgIdIndexRoute = AppCOrgIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppCOrgIdRoute,
} as any)
const AppCOrgIdBranchesRoute = AppCOrgIdBranchesRouteImport.update({
  id: '/branches',
  path: '/branches',
  getParentRoute: () => AppCOrgIdRoute,
} as any)
const AppCOrgIdMyWorkRoute = AppCOrgIdMyWorkRouteImport.update({
  id: '/my-work',
  path: '/my-work',
  getParentRoute: () => AppCOrgIdRoute,
} as any)
const AppCOrgIdOverviewRoute = AppCOrgIdOverviewRouteImport.update({
  id: '/overview',
  path: '/overview',
  getParentRoute: () => AppCOrgIdRoute,
} as any)
const AppCOrgIdProfileRoute = AppCOrgIdProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AppCOrgIdRoute,
} as any)
const AppCOrgIdStaffRoute = AppCOrgIdStaffRouteImport.update({
  id: '/staff',
  path: '/staff',
  getParentRoute: () => AppCOrgIdRoute,
} as any)
const AppCOrgIdCashIndexRoute = AppCOrgIdCashIndexRouteImport.update({
  id: '/cash/',
  path: '/cash/',
  getParentRoute: () => AppCOrgIdRoute,
} as any)
const AppCOrgIdCashHistoryRoute = AppCOrgIdCashHistoryRouteImport.update({
  id: '/cash/history',
  path: '/cash/history',
  getParentRoute: () => AppCOrgIdRoute,
} as any)
const AppCOrgIdClientsIndexRoute = AppCOrgIdClientsIndexRouteImport.update({
  id: '/clients/',
  path: '/clients/',
  getParentRoute: () => AppCOrgIdRoute,
} as any)
const AppCOrgIdClientsClientIdRoute =
  AppCOrgIdClientsClientIdRouteImport.update({
    id: '/clients/$clientId',
    path: '/clients/$clientId',
    getParentRoute: () => AppCOrgIdRoute,
  } as any)
const AppCOrgIdEntryIndexRoute = AppCOrgIdEntryIndexRouteImport.update({
  id: '/entry/',
  path: '/entry/',
  getParentRoute: () => AppCOrgIdRoute,
} as any)
const AppCOrgIdEntryInsideRoute = AppCOrgIdEntryInsideRouteImport.update({
  id: '/entry/inside',
  path: '/entry/inside',
  getParentRoute: () => AppCOrgIdRoute,
} as any)
const AppCOrgIdEntryLockersRoute = AppCOrgIdEntryLockersRouteImport.update({
  id: '/entry/lockers',
  path: '/entry/lockers',
  getParentRoute: () => AppCOrgIdRoute,
} as any)
const AppCOrgIdEntryLogRoute = AppCOrgIdEntryLogRouteImport.update({
  id: '/entry/log',
  path: '/entry/log',
  getParentRoute: () => AppCOrgIdRoute,
} as any)
const AppCOrgIdEntrySettingsRoute = AppCOrgIdEntrySettingsRouteImport.update({
  id: '/entry/settings',
  path: '/entry/settings',
  getParentRoute: () => AppCOrgIdRoute,
} as any)
const AppCOrgIdEntryStatsRoute = AppCOrgIdEntryStatsRouteImport.update({
  id: '/entry/stats',
  path: '/entry/stats',
  getParentRoute: () => AppCOrgIdRoute,
} as any)
const AppCOrgIdGoodsIndexRoute = AppCOrgIdGoodsIndexRouteImport.update({
  id: '/goods/',
  path: '/goods/',
  getParentRoute: () => AppCOrgIdRoute,
} as any)
const AppCOrgIdGoodsProductIdRoute = AppCOrgIdGoodsProductIdRouteImport.update({
  id: '/goods/$productId',
  path: '/goods/$productId',
  getParentRoute: () => AppCOrgIdRoute,
} as any)
const AppCOrgIdGoodsDocumentsRoute = AppCOrgIdGoodsDocumentsRouteImport.update({
  id: '/goods/documents',
  path: '/goods/documents',
  getParentRoute: () => AppCOrgIdRoute,
} as any)
const AppCOrgIdGoodsSalesRoute = AppCOrgIdGoodsSalesRouteImport.update({
  id: '/goods/sales',
  path: '/goods/sales',
  getParentRoute: () => AppCOrgIdRoute,
} as any)
const AppCOrgIdPassesIndexRoute = AppCOrgIdPassesIndexRouteImport.update({
  id: '/passes/',
  path: '/passes/',
  getParentRoute: () => AppCOrgIdRoute,
} as any)
const AppCOrgIdPassesSoldRoute = AppCOrgIdPassesSoldRouteImport.update({
  id: '/passes/sold',
  path: '/passes/sold',
  getParentRoute: () => AppCOrgIdRoute,
} as any)
const AppCOrgIdPayrollIndexRoute = AppCOrgIdPayrollIndexRouteImport.update({
  id: '/payroll/',
  path: '/payroll/',
  getParentRoute: () => AppCOrgIdRoute,
} as any)
const AppCOrgIdPayrollSalariesRoute =
  AppCOrgIdPayrollSalariesRouteImport.update({
    id: '/payroll/salaries',
    path: '/payroll/salaries',
    getParentRoute: () => AppCOrgIdRoute,
  } as any)
const AppCOrgIdRolesIndexRoute = AppCOrgIdRolesIndexRouteImport.update({
  id: '/roles/',
  path: '/roles/',
  getParentRoute: () => AppCOrgIdRoute,
} as any)
const AppCOrgIdRolesRoleIdRoute = AppCOrgIdRolesRoleIdRouteImport.update({
  id: '/roles/$roleId',
  path: '/roles/$roleId',
  getParentRoute: () => AppCOrgIdRoute,
} as any)
const AppCOrgIdRolesNewRoute = AppCOrgIdRolesNewRouteImport.update({
  id: '/roles/new',
  path: '/roles/new',
  getParentRoute: () => AppCOrgIdRoute,
} as any)
const AppCOrgIdServicesIndexRoute = AppCOrgIdServicesIndexRouteImport.update({
  id: '/services/',
  path: '/services/',
  getParentRoute: () => AppCOrgIdRoute,
} as any)
const AppCOrgIdServicesAnalyticsRoute =
  AppCOrgIdServicesAnalyticsRouteImport.update({
    id: '/services/analytics',
    path: '/services/analytics',
    getParentRoute: () => AppCOrgIdRoute,
  } as any)
const AppCOrgIdServicesCatalogueRoute =
  AppCOrgIdServicesCatalogueRouteImport.update({
    id: '/services/catalogue',
    path: '/services/catalogue',
    getParentRoute: () => AppCOrgIdRoute,
  } as any)
const AppCOrgIdServicesHoursRoute = AppCOrgIdServicesHoursRouteImport.update({
  id: '/services/hours',
  path: '/services/hours',
  getParentRoute: () => AppCOrgIdRoute,
} as any)
const AppCOrgIdServicesTimetableRoute =
  AppCOrgIdServicesTimetableRouteImport.update({
    id: '/services/timetable',
    path: '/services/timetable',
    getParentRoute: () => AppCOrgIdRoute,
  } as any)
const AppCOrgIdSettingsIndexRoute = AppCOrgIdSettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => AppCOrgIdRoute,
} as any)
const AppCOrgIdSettingsCashRoute = AppCOrgIdSettingsCashRouteImport.update({
  id: '/settings/cash',
  path: '/settings/cash',
  getParentRoute: () => AppCOrgIdRoute,
} as any)
const AppCOrgIdPassesPlansIndexRoute =
  AppCOrgIdPassesPlansIndexRouteImport.update({
    id: '/passes/plans/',
    path: '/passes/plans/',
    getParentRoute: () => AppCOrgIdRoute,
  } as any)
const AppCOrgIdPassesPlansPlanIdRoute =
  AppCOrgIdPassesPlansPlanIdRouteImport.update({
    id: '/passes/plans/$planId',
    path: '/passes/plans/$planId',
    getParentRoute: () => AppCOrgIdRoute,
  } as any)
const AppCOrgIdPassesPlansNewRoute = AppCOrgIdPassesPlansNewRouteImport.update({
  id: '/passes/plans/new',
  path: '/passes/plans/new',
  getParentRoute: () => AppCOrgIdRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/kiosk': typeof KioskRoute
  '/sign-in': typeof SignInRoute
  '/dev/design': typeof DevDesignRoute
  '/invite/$token': typeof InviteTokenRoute
  '/c/$orgId': typeof AppCOrgIdRouteWithChildren
  '/gods/companies': typeof AppGodsCompaniesRoute
  '/gods/list': typeof AppGodsListRoute
  '/c/$orgId/branches': typeof AppCOrgIdBranchesRoute
  '/c/$orgId/my-work': typeof AppCOrgIdMyWorkRoute
  '/c/$orgId/overview': typeof AppCOrgIdOverviewRoute
  '/c/$orgId/profile': typeof AppCOrgIdProfileRoute
  '/c/$orgId/staff': typeof AppCOrgIdStaffRoute
  '/c/$orgId/': typeof AppCOrgIdIndexRoute
  '/c/$orgId/cash/history': typeof AppCOrgIdCashHistoryRoute
  '/c/$orgId/clients/$clientId': typeof AppCOrgIdClientsClientIdRoute
  '/c/$orgId/entry/inside': typeof AppCOrgIdEntryInsideRoute
  '/c/$orgId/entry/lockers': typeof AppCOrgIdEntryLockersRoute
  '/c/$orgId/entry/log': typeof AppCOrgIdEntryLogRoute
  '/c/$orgId/entry/settings': typeof AppCOrgIdEntrySettingsRoute
  '/c/$orgId/entry/stats': typeof AppCOrgIdEntryStatsRoute
  '/c/$orgId/goods/$productId': typeof AppCOrgIdGoodsProductIdRoute
  '/c/$orgId/goods/documents': typeof AppCOrgIdGoodsDocumentsRoute
  '/c/$orgId/goods/sales': typeof AppCOrgIdGoodsSalesRoute
  '/c/$orgId/passes/sold': typeof AppCOrgIdPassesSoldRoute
  '/c/$orgId/payroll/salaries': typeof AppCOrgIdPayrollSalariesRoute
  '/c/$orgId/roles/$roleId': typeof AppCOrgIdRolesRoleIdRoute
  '/c/$orgId/roles/new': typeof AppCOrgIdRolesNewRoute
  '/c/$orgId/services/analytics': typeof AppCOrgIdServicesAnalyticsRoute
  '/c/$orgId/services/catalogue': typeof AppCOrgIdServicesCatalogueRoute
  '/c/$orgId/services/hours': typeof AppCOrgIdServicesHoursRoute
  '/c/$orgId/services/timetable': typeof AppCOrgIdServicesTimetableRoute
  '/c/$orgId/settings/cash': typeof AppCOrgIdSettingsCashRoute
  '/c/$orgId/cash/': typeof AppCOrgIdCashIndexRoute
  '/c/$orgId/clients/': typeof AppCOrgIdClientsIndexRoute
  '/c/$orgId/entry/': typeof AppCOrgIdEntryIndexRoute
  '/c/$orgId/goods/': typeof AppCOrgIdGoodsIndexRoute
  '/c/$orgId/passes/': typeof AppCOrgIdPassesIndexRoute
  '/c/$orgId/payroll/': typeof AppCOrgIdPayrollIndexRoute
  '/c/$orgId/roles/': typeof AppCOrgIdRolesIndexRoute
  '/c/$orgId/services/': typeof AppCOrgIdServicesIndexRoute
  '/c/$orgId/settings/': typeof AppCOrgIdSettingsIndexRoute
  '/c/$orgId/passes/plans/$planId': typeof AppCOrgIdPassesPlansPlanIdRoute
  '/c/$orgId/passes/plans/new': typeof AppCOrgIdPassesPlansNewRoute
  '/c/$orgId/passes/plans/': typeof AppCOrgIdPassesPlansIndexRoute
}
export interface FileRoutesByTo {
  '/kiosk': typeof KioskRoute
  '/sign-in': typeof SignInRoute
  '/dev/design': typeof DevDesignRoute
  '/invite/$token': typeof InviteTokenRoute
  '/': typeof AppIndexRoute
  '/gods/companies': typeof AppGodsCompaniesRoute
  '/gods/list': typeof AppGodsListRoute
  '/c/$orgId/branches': typeof AppCOrgIdBranchesRoute
  '/c/$orgId/my-work': typeof AppCOrgIdMyWorkRoute
  '/c/$orgId/overview': typeof AppCOrgIdOverviewRoute
  '/c/$orgId/profile': typeof AppCOrgIdProfileRoute
  '/c/$orgId/staff': typeof AppCOrgIdStaffRoute
  '/c/$orgId': typeof AppCOrgIdIndexRoute
  '/c/$orgId/cash/history': typeof AppCOrgIdCashHistoryRoute
  '/c/$orgId/clients/$clientId': typeof AppCOrgIdClientsClientIdRoute
  '/c/$orgId/entry/inside': typeof AppCOrgIdEntryInsideRoute
  '/c/$orgId/entry/lockers': typeof AppCOrgIdEntryLockersRoute
  '/c/$orgId/entry/log': typeof AppCOrgIdEntryLogRoute
  '/c/$orgId/entry/settings': typeof AppCOrgIdEntrySettingsRoute
  '/c/$orgId/entry/stats': typeof AppCOrgIdEntryStatsRoute
  '/c/$orgId/goods/$productId': typeof AppCOrgIdGoodsProductIdRoute
  '/c/$orgId/goods/documents': typeof AppCOrgIdGoodsDocumentsRoute
  '/c/$orgId/goods/sales': typeof AppCOrgIdGoodsSalesRoute
  '/c/$orgId/passes/sold': typeof AppCOrgIdPassesSoldRoute
  '/c/$orgId/payroll/salaries': typeof AppCOrgIdPayrollSalariesRoute
  '/c/$orgId/roles/$roleId': typeof AppCOrgIdRolesRoleIdRoute
  '/c/$orgId/roles/new': typeof AppCOrgIdRolesNewRoute
  '/c/$orgId/services/analytics': typeof AppCOrgIdServicesAnalyticsRoute
  '/c/$orgId/services/catalogue': typeof AppCOrgIdServicesCatalogueRoute
  '/c/$orgId/services/hours': typeof AppCOrgIdServicesHoursRoute
  '/c/$orgId/services/timetable': typeof AppCOrgIdServicesTimetableRoute
  '/c/$orgId/settings/cash': typeof AppCOrgIdSettingsCashRoute
  '/c/$orgId/cash': typeof AppCOrgIdCashIndexRoute
  '/c/$orgId/clients': typeof AppCOrgIdClientsIndexRoute
  '/c/$orgId/entry': typeof AppCOrgIdEntryIndexRoute
  '/c/$orgId/goods': typeof AppCOrgIdGoodsIndexRoute
  '/c/$orgId/passes': typeof AppCOrgIdPassesIndexRoute
  '/c/$orgId/payroll': typeof AppCOrgIdPayrollIndexRoute
  '/c/$orgId/roles': typeof AppCOrgIdRolesIndexRoute
  '/c/$orgId/services': typeof AppCOrgIdServicesIndexRoute
  '/c/$orgId/settings': typeof AppCOrgIdSettingsIndexRoute
  '/c/$orgId/passes/plans/$planId': typeof AppCOrgIdPassesPlansPlanIdRoute
  '/c/$orgId/passes/plans/new': typeof AppCOrgIdPassesPlansNewRoute
  '/c/$orgId/passes/plans': typeof AppCOrgIdPassesPlansIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/kiosk': typeof KioskRoute
  '/sign-in': typeof SignInRoute
  '/dev/design': typeof DevDesignRoute
  '/invite/$token': typeof InviteTokenRoute
  '/_app/': typeof AppIndexRoute
  '/_app/c/$orgId': typeof AppCOrgIdRouteWithChildren
  '/_app/gods/companies': typeof AppGodsCompaniesRoute
  '/_app/gods/list': typeof AppGodsListRoute
  '/_app/c/$orgId/branches': typeof AppCOrgIdBranchesRoute
  '/_app/c/$orgId/my-work': typeof AppCOrgIdMyWorkRoute
  '/_app/c/$orgId/overview': typeof AppCOrgIdOverviewRoute
  '/_app/c/$orgId/profile': typeof AppCOrgIdProfileRoute
  '/_app/c/$orgId/staff': typeof AppCOrgIdStaffRoute
  '/_app/c/$orgId/': typeof AppCOrgIdIndexRoute
  '/_app/c/$orgId/cash/history': typeof AppCOrgIdCashHistoryRoute
  '/_app/c/$orgId/clients/$clientId': typeof AppCOrgIdClientsClientIdRoute
  '/_app/c/$orgId/entry/inside': typeof AppCOrgIdEntryInsideRoute
  '/_app/c/$orgId/entry/lockers': typeof AppCOrgIdEntryLockersRoute
  '/_app/c/$orgId/entry/log': typeof AppCOrgIdEntryLogRoute
  '/_app/c/$orgId/entry/settings': typeof AppCOrgIdEntrySettingsRoute
  '/_app/c/$orgId/entry/stats': typeof AppCOrgIdEntryStatsRoute
  '/_app/c/$orgId/goods/$productId': typeof AppCOrgIdGoodsProductIdRoute
  '/_app/c/$orgId/goods/documents': typeof AppCOrgIdGoodsDocumentsRoute
  '/_app/c/$orgId/goods/sales': typeof AppCOrgIdGoodsSalesRoute
  '/_app/c/$orgId/passes/sold': typeof AppCOrgIdPassesSoldRoute
  '/_app/c/$orgId/payroll/salaries': typeof AppCOrgIdPayrollSalariesRoute
  '/_app/c/$orgId/roles/$roleId': typeof AppCOrgIdRolesRoleIdRoute
  '/_app/c/$orgId/roles/new': typeof AppCOrgIdRolesNewRoute
  '/_app/c/$orgId/services/analytics': typeof AppCOrgIdServicesAnalyticsRoute
  '/_app/c/$orgId/services/catalogue': typeof AppCOrgIdServicesCatalogueRoute
  '/_app/c/$orgId/services/hours': typeof AppCOrgIdServicesHoursRoute
  '/_app/c/$orgId/services/timetable': typeof AppCOrgIdServicesTimetableRoute
  '/_app/c/$orgId/settings/cash': typeof AppCOrgIdSettingsCashRoute
  '/_app/c/$orgId/cash/': typeof AppCOrgIdCashIndexRoute
  '/_app/c/$orgId/clients/': typeof AppCOrgIdClientsIndexRoute
  '/_app/c/$orgId/entry/': typeof AppCOrgIdEntryIndexRoute
  '/_app/c/$orgId/goods/': typeof AppCOrgIdGoodsIndexRoute
  '/_app/c/$orgId/passes/': typeof AppCOrgIdPassesIndexRoute
  '/_app/c/$orgId/payroll/': typeof AppCOrgIdPayrollIndexRoute
  '/_app/c/$orgId/roles/': typeof AppCOrgIdRolesIndexRoute
  '/_app/c/$orgId/services/': typeof AppCOrgIdServicesIndexRoute
  '/_app/c/$orgId/settings/': typeof AppCOrgIdSettingsIndexRoute
  '/_app/c/$orgId/passes/plans/$planId': typeof AppCOrgIdPassesPlansPlanIdRoute
  '/_app/c/$orgId/passes/plans/new': typeof AppCOrgIdPassesPlansNewRoute
  '/_app/c/$orgId/passes/plans/': typeof AppCOrgIdPassesPlansIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/kiosk'
    | '/sign-in'
    | '/dev/design'
    | '/invite/$token'
    | '/c/$orgId'
    | '/gods/companies'
    | '/gods/list'
    | '/c/$orgId/branches'
    | '/c/$orgId/my-work'
    | '/c/$orgId/overview'
    | '/c/$orgId/profile'
    | '/c/$orgId/staff'
    | '/c/$orgId/'
    | '/c/$orgId/cash/history'
    | '/c/$orgId/clients/$clientId'
    | '/c/$orgId/entry/inside'
    | '/c/$orgId/entry/lockers'
    | '/c/$orgId/entry/log'
    | '/c/$orgId/entry/settings'
    | '/c/$orgId/entry/stats'
    | '/c/$orgId/goods/$productId'
    | '/c/$orgId/goods/documents'
    | '/c/$orgId/goods/sales'
    | '/c/$orgId/passes/sold'
    | '/c/$orgId/payroll/salaries'
    | '/c/$orgId/roles/$roleId'
    | '/c/$orgId/roles/new'
    | '/c/$orgId/services/analytics'
    | '/c/$orgId/services/catalogue'
    | '/c/$orgId/services/hours'
    | '/c/$orgId/services/timetable'
    | '/c/$orgId/settings/cash'
    | '/c/$orgId/cash/'
    | '/c/$orgId/clients/'
    | '/c/$orgId/entry/'
    | '/c/$orgId/goods/'
    | '/c/$orgId/passes/'
    | '/c/$orgId/payroll/'
    | '/c/$orgId/roles/'
    | '/c/$orgId/services/'
    | '/c/$orgId/settings/'
    | '/c/$orgId/passes/plans/$planId'
    | '/c/$orgId/passes/plans/new'
    | '/c/$orgId/passes/plans/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/kiosk'
    | '/sign-in'
    | '/dev/design'
    | '/invite/$token'
    | '/'
    | '/gods/companies'
    | '/gods/list'
    | '/c/$orgId/branches'
    | '/c/$orgId/my-work'
    | '/c/$orgId/overview'
    | '/c/$orgId/profile'
    | '/c/$orgId/staff'
    | '/c/$orgId'
    | '/c/$orgId/cash/history'
    | '/c/$orgId/clients/$clientId'
    | '/c/$orgId/entry/inside'
    | '/c/$orgId/entry/lockers'
    | '/c/$orgId/entry/log'
    | '/c/$orgId/entry/settings'
    | '/c/$orgId/entry/stats'
    | '/c/$orgId/goods/$productId'
    | '/c/$orgId/goods/documents'
    | '/c/$orgId/goods/sales'
    | '/c/$orgId/passes/sold'
    | '/c/$orgId/payroll/salaries'
    | '/c/$orgId/roles/$roleId'
    | '/c/$orgId/roles/new'
    | '/c/$orgId/services/analytics'
    | '/c/$orgId/services/catalogue'
    | '/c/$orgId/services/hours'
    | '/c/$orgId/services/timetable'
    | '/c/$orgId/settings/cash'
    | '/c/$orgId/cash'
    | '/c/$orgId/clients'
    | '/c/$orgId/entry'
    | '/c/$orgId/goods'
    | '/c/$orgId/passes'
    | '/c/$orgId/payroll'
    | '/c/$orgId/roles'
    | '/c/$orgId/services'
    | '/c/$orgId/settings'
    | '/c/$orgId/passes/plans/$planId'
    | '/c/$orgId/passes/plans/new'
    | '/c/$orgId/passes/plans'
  id:
    | '__root__'
    | '/_app'
    | '/kiosk'
    | '/sign-in'
    | '/dev/design'
    | '/invite/$token'
    | '/_app/'
    | '/_app/c/$orgId'
    | '/_app/gods/companies'
    | '/_app/gods/list'
    | '/_app/c/$orgId/branches'
    | '/_app/c/$orgId/my-work'
    | '/_app/c/$orgId/overview'
    | '/_app/c/$orgId/profile'
    | '/_app/c/$orgId/staff'
    | '/_app/c/$orgId/'
    | '/_app/c/$orgId/cash/history'
    | '/_app/c/$orgId/clients/$clientId'
    | '/_app/c/$orgId/entry/inside'
    | '/_app/c/$orgId/entry/lockers'
    | '/_app/c/$orgId/entry/log'
    | '/_app/c/$orgId/entry/settings'
    | '/_app/c/$orgId/entry/stats'
    | '/_app/c/$orgId/goods/$productId'
    | '/_app/c/$orgId/goods/documents'
    | '/_app/c/$orgId/goods/sales'
    | '/_app/c/$orgId/passes/sold'
    | '/_app/c/$orgId/payroll/salaries'
    | '/_app/c/$orgId/roles/$roleId'
    | '/_app/c/$orgId/roles/new'
    | '/_app/c/$orgId/services/analytics'
    | '/_app/c/$orgId/services/catalogue'
    | '/_app/c/$orgId/services/hours'
    | '/_app/c/$orgId/services/timetable'
    | '/_app/c/$orgId/settings/cash'
    | '/_app/c/$orgId/cash/'
    | '/_app/c/$orgId/clients/'
    | '/_app/c/$orgId/entry/'
    | '/_app/c/$orgId/goods/'
    | '/_app/c/$orgId/passes/'
    | '/_app/c/$orgId/payroll/'
    | '/_app/c/$orgId/roles/'
    | '/_app/c/$orgId/services/'
    | '/_app/c/$orgId/settings/'
    | '/_app/c/$orgId/passes/plans/$planId'
    | '/_app/c/$orgId/passes/plans/new'
    | '/_app/c/$orgId/passes/plans/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  KioskRoute: typeof KioskRoute
  SignInRoute: typeof SignInRoute
  DevDesignRoute: typeof DevDesignRoute
  InviteTokenRoute: typeof InviteTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/kiosk': {
      id: '/kiosk'
      path: '/kiosk'
      fullPath: '/kiosk'
      preLoaderRoute: typeof KioskRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-in': {
      id: '/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/dev/design': {
      id: '/dev/design'
      path: '/dev/design'
      fullPath: '/dev/design'
      preLoaderRoute: typeof DevDesignRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invite/$token': {
      id: '/invite/$token'
      path: '/invite/$token'
      fullPath: '/invite/$token'
      preLoaderRoute: typeof InviteTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/c/$orgId': {
      id: '/_app/c/$orgId'
      path: '/c/$orgId'
      fullPath: '/c/$orgId'
      preLoaderRoute: typeof AppCOrgIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/gods/companies': {
      id: '/_app/gods/companies'
      path: '/gods/companies'
      fullPath: '/gods/companies'
      preLoaderRoute: typeof AppGodsCompaniesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/gods/list': {
      id: '/_app/gods/list'
      path: '/gods/list'
      fullPath: '/gods/list'
      preLoaderRoute: typeof AppGodsListRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/c/$orgId/': {
      id: '/_app/c/$orgId/'
      path: '/'
      fullPath: '/c/$orgId/'
      preLoaderRoute: typeof AppCOrgIdIndexRouteImport
      parentRoute: typeof AppCOrgIdRoute
    }
    '/_app/c/$orgId/branches': {
      id: '/_app/c/$orgId/branches'
      path: '/branches'
      fullPath: '/c/$orgId/branches'
      preLoaderRoute: typeof AppCOrgIdBranchesRouteImport
      parentRoute: typeof AppCOrgIdRoute
    }
    '/_app/c/$orgId/my-work': {
      id: '/_app/c/$orgId/my-work'
      path: '/my-work'
      fullPath: '/c/$orgId/my-work'
      preLoaderRoute: typeof AppCOrgIdMyWorkRouteImport
      parentRoute: typeof AppCOrgIdRoute
    }
    '/_app/c/$orgId/overview': {
      id: '/_app/c/$orgId/overview'
      path: '/overview'
      fullPath: '/c/$orgId/overview'
      preLoaderRoute: typeof AppCOrgIdOverviewRouteImport
      parentRoute: typeof AppCOrgIdRoute
    }
    '/_app/c/$orgId/profile': {
      id: '/_app/c/$orgId/profile'
      path: '/profile'
      fullPath: '/c/$orgId/profile'
      preLoaderRoute: typeof AppCOrgIdProfileRouteImport
      parentRoute: typeof AppCOrgIdRoute
    }
    '/_app/c/$orgId/staff': {
      id: '/_app/c/$orgId/staff'
      path: '/staff'
      fullPath: '/c/$orgId/staff'
      preLoaderRoute: typeof AppCOrgIdStaffRouteImport
      parentRoute: typeof AppCOrgIdRoute
    }
    '/_app/c/$orgId/cash/': {
      id: '/_app/c/$orgId/cash/'
      path: '/cash'
      fullPath: '/c/$orgId/cash/'
      preLoaderRoute: typeof AppCOrgIdCashIndexRouteImport
      parentRoute: typeof AppCOrgIdRoute
    }
    '/_app/c/$orgId/cash/history': {
      id: '/_app/c/$orgId/cash/history'
      path: '/cash/history'
      fullPath: '/c/$orgId/cash/history'
      preLoaderRoute: typeof AppCOrgIdCashHistoryRouteImport
      parentRoute: typeof AppCOrgIdRoute
    }
    '/_app/c/$orgId/clients/': {
      id: '/_app/c/$orgId/clients/'
      path: '/clients'
      fullPath: '/c/$orgId/clients/'
      preLoaderRoute: typeof AppCOrgIdClientsIndexRouteImport
      parentRoute: typeof AppCOrgIdRoute
    }
    '/_app/c/$orgId/clients/$clientId': {
      id: '/_app/c/$orgId/clients/$clientId'
      path: '/clients/$clientId'
      fullPath: '/c/$orgId/clients/$clientId'
      preLoaderRoute: typeof AppCOrgIdClientsClientIdRouteImport
      parentRoute: typeof AppCOrgIdRoute
    }
    '/_app/c/$orgId/entry/': {
      id: '/_app/c/$orgId/entry/'
      path: '/entry'
      fullPath: '/c/$orgId/entry/'
      preLoaderRoute: typeof AppCOrgIdEntryIndexRouteImport
      parentRoute: typeof AppCOrgIdRoute
    }
    '/_app/c/$orgId/entry/inside': {
      id: '/_app/c/$orgId/entry/inside'
      path: '/entry/inside'
      fullPath: '/c/$orgId/entry/inside'
      preLoaderRoute: typeof AppCOrgIdEntryInsideRouteImport
      parentRoute: typeof AppCOrgIdRoute
    }
    '/_app/c/$orgId/entry/lockers': {
      id: '/_app/c/$orgId/entry/lockers'
      path: '/entry/lockers'
      fullPath: '/c/$orgId/entry/lockers'
      preLoaderRoute: typeof AppCOrgIdEntryLockersRouteImport
      parentRoute: typeof AppCOrgIdRoute
    }
    '/_app/c/$orgId/entry/log': {
      id: '/_app/c/$orgId/entry/log'
      path: '/entry/log'
      fullPath: '/c/$orgId/entry/log'
      preLoaderRoute: typeof AppCOrgIdEntryLogRouteImport
      parentRoute: typeof AppCOrgIdRoute
    }
    '/_app/c/$orgId/entry/settings': {
      id: '/_app/c/$orgId/entry/settings'
      path: '/entry/settings'
      fullPath: '/c/$orgId/entry/settings'
      preLoaderRoute: typeof AppCOrgIdEntrySettingsRouteImport
      parentRoute: typeof AppCOrgIdRoute
    }
    '/_app/c/$orgId/entry/stats': {
      id: '/_app/c/$orgId/entry/stats'
      path: '/entry/stats'
      fullPath: '/c/$orgId/entry/stats'
      preLoaderRoute: typeof AppCOrgIdEntryStatsRouteImport
      parentRoute: typeof AppCOrgIdRoute
    }
    '/_app/c/$orgId/goods/': {
      id: '/_app/c/$orgId/goods/'
      path: '/goods'
      fullPath: '/c/$orgId/goods/'
      preLoaderRoute: typeof AppCOrgIdGoodsIndexRouteImport
      parentRoute: typeof AppCOrgIdRoute
    }
    '/_app/c/$orgId/goods/$productId': {
      id: '/_app/c/$orgId/goods/$productId'
      path: '/goods/$productId'
      fullPath: '/c/$orgId/goods/$productId'
      preLoaderRoute: typeof AppCOrgIdGoodsProductIdRouteImport
      parentRoute: typeof AppCOrgIdRoute
    }
    '/_app/c/$orgId/goods/documents': {
      id: '/_app/c/$orgId/goods/documents'
      path: '/goods/documents'
      fullPath: '/c/$orgId/goods/documents'
      preLoaderRoute: typeof AppCOrgIdGoodsDocumentsRouteImport
      parentRoute: typeof AppCOrgIdRoute
    }
    '/_app/c/$orgId/goods/sales': {
      id: '/_app/c/$orgId/goods/sales'
      path: '/goods/sales'
      fullPath: '/c/$orgId/goods/sales'
      preLoaderRoute: typeof AppCOrgIdGoodsSalesRouteImport
      parentRoute: typeof AppCOrgIdRoute
    }
    '/_app/c/$orgId/passes/': {
      id: '/_app/c/$orgId/passes/'
      path: '/passes'
      fullPath: '/c/$orgId/passes/'
      preLoaderRoute: typeof AppCOrgIdPassesIndexRouteImport
      parentRoute: typeof AppCOrgIdRoute
    }
    '/_app/c/$orgId/passes/sold': {
      id: '/_app/c/$orgId/passes/sold'
      path: '/passes/sold'
      fullPath: '/c/$orgId/passes/sold'
      preLoaderRoute: typeof AppCOrgIdPassesSoldRouteImport
      parentRoute: typeof AppCOrgIdRoute
    }
    '/_app/c/$orgId/payroll/': {
      id: '/_app/c/$orgId/payroll/'
      path: '/payroll'
      fullPath: '/c/$orgId/payroll/'
      preLoaderRoute: typeof AppCOrgIdPayrollIndexRouteImport
      parentRoute: typeof AppCOrgIdRoute
    }
    '/_app/c/$orgId/payroll/salaries': {
      id: '/_app/c/$orgId/payroll/salaries'
      path: '/payroll/salaries'
      fullPath: '/c/$orgId/payroll/salaries'
      preLoaderRoute: typeof AppCOrgIdPayrollSalariesRouteImport
      parentRoute: typeof AppCOrgIdRoute
    }
    '/_app/c/$orgId/roles/': {
      id: '/_app/c/$orgId/roles/'
      path: '/roles'
      fullPath: '/c/$orgId/roles/'
      preLoaderRoute: typeof AppCOrgIdRolesIndexRouteImport
      parentRoute: typeof AppCOrgIdRoute
    }
    '/_app/c/$orgId/roles/$roleId': {
      id: '/_app/c/$orgId/roles/$roleId'
      path: '/roles/$roleId'
      fullPath: '/c/$orgId/roles/$roleId'
      preLoaderRoute: typeof AppCOrgIdRolesRoleIdRouteImport
      parentRoute: typeof AppCOrgIdRoute
    }
    '/_app/c/$orgId/roles/new': {
      id: '/_app/c/$orgId/roles/new'
      path: '/roles/new'
      fullPath: '/c/$orgId/roles/new'
      preLoaderRoute: typeof AppCOrgIdRolesNewRouteImport
      parentRoute: typeof AppCOrgIdRoute
    }
    '/_app/c/$orgId/services/': {
      id: '/_app/c/$orgId/services/'
      path: '/services'
      fullPath: '/c/$orgId/services/'
      preLoaderRoute: typeof AppCOrgIdServicesIndexRouteImport
      parentRoute: typeof AppCOrgIdRoute
    }
    '/_app/c/$orgId/services/analytics': {
      id: '/_app/c/$orgId/services/analytics'
      path: '/services/analytics'
      fullPath: '/c/$orgId/services/analytics'
      preLoaderRoute: typeof AppCOrgIdServicesAnalyticsRouteImport
      parentRoute: typeof AppCOrgIdRoute
    }
    '/_app/c/$orgId/services/catalogue': {
      id: '/_app/c/$orgId/services/catalogue'
      path: '/services/catalogue'
      fullPath: '/c/$orgId/services/catalogue'
      preLoaderRoute: typeof AppCOrgIdServicesCatalogueRouteImport
      parentRoute: typeof AppCOrgIdRoute
    }
    '/_app/c/$orgId/services/hours': {
      id: '/_app/c/$orgId/services/hours'
      path: '/services/hours'
      fullPath: '/c/$orgId/services/hours'
      preLoaderRoute: typeof AppCOrgIdServicesHoursRouteImport
      parentRoute: typeof AppCOrgIdRoute
    }
    '/_app/c/$orgId/services/timetable': {
      id: '/_app/c/$orgId/services/timetable'
      path: '/services/timetable'
      fullPath: '/c/$orgId/services/timetable'
      preLoaderRoute: typeof AppCOrgIdServicesTimetableRouteImport
      parentRoute: typeof AppCOrgIdRoute
    }
    '/_app/c/$orgId/settings/': {
      id: '/_app/c/$orgId/settings/'
      path: '/settings'
      fullPath: '/c/$orgId/settings/'
      preLoaderRoute: typeof AppCOrgIdSettingsIndexRouteImport
      parentRoute: typeof AppCOrgIdRoute
    }
    '/_app/c/$orgId/settings/cash': {
      id: '/_app/c/$orgId/settings/cash'
      path: '/settings/cash'
      fullPath: '/c/$orgId/settings/cash'
      preLoaderRoute: typeof AppCOrgIdSettingsCashRouteImport
      parentRoute: typeof AppCOrgIdRoute
    }
    '/_app/c/$orgId/passes/plans/': {
      id: '/_app/c/$orgId/passes/plans/'
      path: '/passes/plans'
      fullPath: '/c/$orgId/passes/plans/'
      preLoaderRoute: typeof AppCOrgIdPassesPlansIndexRouteImport
      parentRoute: typeof AppCOrgIdRoute
    }
    '/_app/c/$orgId/passes/plans/$planId': {
      id: '/_app/c/$orgId/passes/plans/$planId'
      path: '/passes/plans/$planId'
      fullPath: '/c/$orgId/passes/plans/$planId'
      preLoaderRoute: typeof AppCOrgIdPassesPlansPlanIdRouteImport
      parentRoute: typeof AppCOrgIdRoute
    }
    '/_app/c/$orgId/passes/plans/new': {
      id: '/_app/c/$orgId/passes/plans/new'
      path: '/passes/plans/new'
      fullPath: '/c/$orgId/passes/plans/new'
      preLoaderRoute: typeof AppCOrgIdPassesPlansNewRouteImport
      parentRoute: typeof AppCOrgIdRoute
    }
  }
}

interface AppCOrgIdRouteChildren {
  AppCOrgIdBranchesRoute: typeof AppCOrgIdBranchesRoute
  AppCOrgIdMyWorkRoute: typeof AppCOrgIdMyWorkRoute
  AppCOrgIdOverviewRoute: typeof AppCOrgIdOverviewRoute
  AppCOrgIdProfileRoute: typeof AppCOrgIdProfileRoute
  AppCOrgIdStaffRoute: typeof AppCOrgIdStaffRoute
  AppCOrgIdIndexRoute: typeof AppCOrgIdIndexRoute
  AppCOrgIdCashHistoryRoute: typeof AppCOrgIdCashHistoryRoute
  AppCOrgIdClientsClientIdRoute: typeof AppCOrgIdClientsClientIdRoute
  AppCOrgIdEntryInsideRoute: typeof AppCOrgIdEntryInsideRoute
  AppCOrgIdEntryLockersRoute: typeof AppCOrgIdEntryLockersRoute
  AppCOrgIdEntryLogRoute: typeof AppCOrgIdEntryLogRoute
  AppCOrgIdEntrySettingsRoute: typeof AppCOrgIdEntrySettingsRoute
  AppCOrgIdEntryStatsRoute: typeof AppCOrgIdEntryStatsRoute
  AppCOrgIdGoodsProductIdRoute: typeof AppCOrgIdGoodsProductIdRoute
  AppCOrgIdGoodsDocumentsRoute: typeof AppCOrgIdGoodsDocumentsRoute
  AppCOrgIdGoodsSalesRoute: typeof AppCOrgIdGoodsSalesRoute
  AppCOrgIdPassesSoldRoute: typeof AppCOrgIdPassesSoldRoute
  AppCOrgIdPayrollSalariesRoute: typeof AppCOrgIdPayrollSalariesRoute
  AppCOrgIdRolesRoleIdRoute: typeof AppCOrgIdRolesRoleIdRoute
  AppCOrgIdRolesNewRoute: typeof AppCOrgIdRolesNewRoute
  AppCOrgIdServicesAnalyticsRoute: typeof AppCOrgIdServicesAnalyticsRoute
  AppCOrgIdServicesCatalogueRoute: typeof AppCOrgIdServicesCatalogueRoute
  AppCOrgIdServicesHoursRoute: typeof AppCOrgIdServicesHoursRoute
  AppCOrgIdServicesTimetableRoute: typeof AppCOrgIdServicesTimetableRoute
  AppCOrgIdSettingsCashRoute: typeof AppCOrgIdSettingsCashRoute
  AppCOrgIdCashIndexRoute: typeof AppCOrgIdCashIndexRoute
  AppCOrgIdClientsIndexRoute: typeof AppCOrgIdClientsIndexRoute
  AppCOrgIdEntryIndexRoute: typeof AppCOrgIdEntryIndexRoute
  AppCOrgIdGoodsIndexRoute: typeof AppCOrgIdGoodsIndexRoute
  AppCOrgIdPassesIndexRoute: typeof AppCOrgIdPassesIndexRoute
  AppCOrgIdPayrollIndexRoute: typeof AppCOrgIdPayrollIndexRoute
  AppCOrgIdRolesIndexRoute: typeof AppCOrgIdRolesIndexRoute
  AppCOrgIdServicesIndexRoute: typeof AppCOrgIdServicesIndexRoute
  AppCOrgIdSettingsIndexRoute: typeof AppCOrgIdSettingsIndexRoute
  AppCOrgIdPassesPlansPlanIdRoute: typeof AppCOrgIdPassesPlansPlanIdRoute
  AppCOrgIdPassesPlansNewRoute: typeof AppCOrgIdPassesPlansNewRoute
  AppCOrgIdPassesPlansIndexRoute: typeof AppCOrgIdPassesPlansIndexRoute
}

const AppCOrgIdRouteChildren: AppCOrgIdRouteChildren = {
  AppCOrgIdBranchesRoute: AppCOrgIdBranchesRoute,
  AppCOrgIdMyWorkRoute: AppCOrgIdMyWorkRoute,
  AppCOrgIdOverviewRoute: AppCOrgIdOverviewRoute,
  AppCOrgIdProfileRoute: AppCOrgIdProfileRoute,
  AppCOrgIdStaffRoute: AppCOrgIdStaffRoute,
  AppCOrgIdIndexRoute: AppCOrgIdIndexRoute,
  AppCOrgIdCashHistoryRoute: AppCOrgIdCashHistoryRoute,
  AppCOrgIdClientsClientIdRoute: AppCOrgIdClientsClientIdRoute,
  AppCOrgIdEntryInsideRoute: AppCOrgIdEntryInsideRoute,
  AppCOrgIdEntryLockersRoute: AppCOrgIdEntryLockersRoute,
  AppCOrgIdEntryLogRoute: AppCOrgIdEntryLogRoute,
  AppCOrgIdEntrySettingsRoute: AppCOrgIdEntrySettingsRoute,
  AppCOrgIdEntryStatsRoute: AppCOrgIdEntryStatsRoute,
  AppCOrgIdGoodsProductIdRoute: AppCOrgIdGoodsProductIdRoute,
  AppCOrgIdGoodsDocumentsRoute: AppCOrgIdGoodsDocumentsRoute,
  AppCOrgIdGoodsSalesRoute: AppCOrgIdGoodsSalesRoute,
  AppCOrgIdPassesSoldRoute: AppCOrgIdPassesSoldRoute,
  AppCOrgIdPayrollSalariesRoute: AppCOrgIdPayrollSalariesRoute,
  AppCOrgIdRolesRoleIdRoute: AppCOrgIdRolesRoleIdRoute,
  AppCOrgIdRolesNewRoute: AppCOrgIdRolesNewRoute,
  AppCOrgIdServicesAnalyticsRoute: AppCOrgIdServicesAnalyticsRoute,
  AppCOrgIdServicesCatalogueRoute: AppCOrgIdServicesCatalogueRoute,
  AppCOrgIdServicesHoursRoute: AppCOrgIdServicesHoursRoute,
  AppCOrgIdServicesTimetableRoute: AppCOrgIdServicesTimetableRoute,
  AppCOrgIdSettingsCashRoute: AppCOrgIdSettingsCashRoute,
  AppCOrgIdCashIndexRoute: AppCOrgIdCashIndexRoute,
  AppCOrgIdClientsIndexRoute: AppCOrgIdClientsIndexRoute,
  AppCOrgIdEntryIndexRoute: AppCOrgIdEntryIndexRoute,
  AppCOrgIdGoodsIndexRoute: AppCOrgIdGoodsIndexRoute,
  AppCOrgIdPassesIndexRoute: AppCOrgIdPassesIndexRoute,
  AppCOrgIdPayrollIndexRoute: AppCOrgIdPayrollIndexRoute,
  AppCOrgIdRolesIndexRoute: AppCOrgIdRolesIndexRoute,
  AppCOrgIdServicesIndexRoute: AppCOrgIdServicesIndexRoute,
  AppCOrgIdSettingsIndexRoute: AppCOrgIdSettingsIndexRoute,
  AppCOrgIdPassesPlansPlanIdRoute: AppCOrgIdPassesPlansPlanIdRoute,
  AppCOrgIdPassesPlansNewRoute: AppCOrgIdPassesPlansNewRoute,
  AppCOrgIdPassesPlansIndexRoute: AppCOrgIdPassesPlansIndexRoute,
}

const AppCOrgIdRouteWithChildren = AppCOrgIdRoute._addFileChildren(
  AppCOrgIdRouteChildren,
)

interface AppRouteChildren {
  AppIndexRoute: typeof AppIndexRoute
  AppCOrgIdRoute: typeof AppCOrgIdRouteWithChildren
  AppGodsCompaniesRoute: typeof AppGodsCompaniesRoute
  AppGodsListRoute: typeof AppGodsListRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppIndexRoute: AppIndexRoute,
  AppCOrgIdRoute: AppCOrgIdRouteWithChildren,
  AppGodsCompaniesRoute: AppGodsCompaniesRoute,
  AppGodsListRoute: AppGodsListRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  KioskRoute: KioskRoute,
  SignInRoute: SignInRoute,
  DevDesignRoute: DevDesignRoute,
  InviteTokenRoute: InviteTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
